import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Loader from './components/Loader';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import ScrollToTop from './components/common/ScrollToTop';
import { WhatsAppIcon } from './components/common/Icons';

import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Contact from './pages/Contact';

import './styles/global.css';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      // Small delay so the logo animation is visible
      setTimeout(() => {
        setLoading(false);
      }, 1200);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
    }

    return () => window.removeEventListener('load', handleLoad);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <ScrollToTop />

      <div className="App">
        <Header />

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>

        <Footer />
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/919911949911?text=Namaste%2C%20main%20aapse%20judna%20chahta%20hoon%20is%20baare%20mein%20aur%20jaankari%20lene%20ke%20liye."
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact on WhatsApp"
      >
        <WhatsAppIcon width={35} height={35} fill="white" />
      </a>
    </Router>
  );
}

export default App;